
const LongReadNav = ({ sections, link }) => (
  <nav className="navbar long-read-menu bg-main">
    <div className="container justify-content-start">
      {sections.map((_, k) => (
        <a key={k} href={`#${link}-${k+1}`} className="h3 nav-link no-underline text-secondary">
          {k + 1}
        </a>
      ))}
    </div>
  </nav>
);

const LeadSection = ({ leadImage, heading }) => (
  <section className="container-fluid d-css mt-120px mt-lg-130px bg-white">
    <div className="row">
      <div className="col-12 bg-long-read-lead px-0 py-0" style={{ backgroundImage: `url(${leadImage})` }}>
        <img src={leadImage} className="img-fluid invisible" loading="lazy" />
      </div>
    </div>
  </section>
);

const ContentSection = ({ content, date, link, sections }) => (
  <section className="container-fluid bg-white">
    <div className="container longread-container">
      <div className="row justify-content-center py-5">
        <div className="col-12 text-italic d-css text-12px mb-1">
          {date}
        </div>
        <div className="col-12 text-italic mb-3">
          {content.join(' ')}
        </div>
        <div className="col-12 my-3">
          <h2>Содержание</h2>
        </div>
        {sections.map((section, k) => (
          <SectionContent key={k} section={section} k={k} link={link} />
        ))}
      </div>
    </div>
  </section>
);

const SectionContent = ({ section, k, link }) => (
  <>
    {section.sec_heading && (
      <div className="col-12 heading-link mb-1">
        <a href={`#${link}-${k+1}`} className="px-md-3 h3">
          <i className="fa fa-angle-right fa-sm"></i> {section.sec_heading}
        </a>
      </div>
    )}
    {section.paragraphs.map((par, i) => (
      <ParagraphRenderer key={i} par={par} k={k} i={i} link={link} />
    ))}
  </>
);

const ParagraphRenderer = ({ par, k, i, link }) => {
  switch(par.type) {
    case 'subheading':
      return (
        <div className="col-12 heading-link mb-1">
          <a href={`#${link}-${k+1}-${i+1}`} className="px-3 px-md-4 h4">
            <i className="fa fa-angle-right fa-sm"></i> {par.src}
          </a>
        </div>
      );
    // Add other cases as needed
    default:
      return null;
  }
};

export const LongRead = ({ post }) => {
  const { lead_image, heading, content, date, sections, link, bg } = post;

  return (
    <>
      <LongReadNav sections={sections} link={link} />
      
      {!lead_image ? (
        <section className="container-fluid">
          <div className="container longread-container h-100">
            <div className="row justify-content-center align-items-center" style={{ height: '100vh' }}>
              <h1 className="col-12 h1 mb-3 text-white text-center text-extra-large">
                {heading}
              </h1>
            </div>
          </div>
        </section>
      ) : (
        <LeadSection leadImage={lead_image} heading={heading} />
      )}

      <ContentSection 
        content={content} 
        date={date} 
        link={link} 
        sections={sections}       />

      {sections.map((section, k) => (
        <SectionBlock 
          key={k} 
          section={section} 
          k={k} 
          link={link} 
          isLast={k === sections.length - 1} 
        />
      ))}

      <section 
        className="bg-fixed-full-page" 
        style={{ backgroundImage: `url(${bg})`, zIndex: -1 }}
      />
    </>
  );
};